// extracted by mini-css-extract-plugin
module.exports = {"iframe":"tutorial_iframe__wfDXg","select":"tutorial_select__1lxsF","blank":"tutorial_blank__3Gh1O"};